// JS
import 'bootstrap-italia/dist/bootstrap-italia.esm.js';
import 'leaflet/dist/leaflet-src.esm.js';
import './assets/js/main.js';
// CSS
import './assets/scss/main.scss';
// ASSETS
require('bootstrap-italia/dist/svg/sprites.svg');
